/**
 * @generated SignedSource<<77de9b46b8d3dd5e552f090d378ad959>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ChainIdentifier = "ABSTRACT_TESTNET" | "AMOY" | "APE_CHAIN" | "APE_CURTIS" | "ARBITRUM" | "ARBITRUM_NOVA" | "ARBITRUM_SEPOLIA" | "AVALANCHE" | "AVALANCHE_FUJI" | "B3" | "B3_SEPOLIA" | "BAOBAB" | "BASE" | "BASE_SEPOLIA" | "BERA_CHAIN" | "BLAST" | "BLAST_SEPOLIA" | "BSC" | "BSC_TESTNET" | "ETHEREUM" | "FLOW" | "FLOW_TESTNET" | "GUNZILLA" | "GUNZILLA_TESTNET" | "KLAYTN" | "MATIC" | "MONAD_TESTNET" | "OPTIMISM" | "OPTIMISM_SEPOLIA" | "RONIN" | "SAIGON_TESTNET" | "SEI" | "SEI_TESTNET" | "SEPOLIA" | "SHAPE" | "SOLANA" | "SOLDEV" | "SONEIUM" | "SONEIUM_MINATO" | "UNICHAIN" | "ZORA" | "ZORA_SEPOLIA" | "ZORA_TESTNET" | "%future added value";
export type useFetchAllWalletBalancesQuery$variables = {
  address: string;
  chain?: | "ETHEREUM" | "MATIC" | "KLAYTN" | "BSC" | "SOLANA" | "ARBITRUM" | "ARBITRUM_NOVA" | "AVALANCHE" | "OPTIMISM" | "OPTIMISM_SEPOLIA" | "AMOY" | "BAOBAB" | "BSC_TESTNET" | "SOLDEV" | "ARBITRUM_SEPOLIA" | "AVALANCHE_FUJI" | "SEPOLIA" | "BASE" | "BASE_SEPOLIA" | "ZORA" | "ZORA_SEPOLIA" | "ZORA_TESTNET"  | "FLOW" | "FLOW_TESTNET" | "BLAST_SEPOLIA" | "BLAST" | "GUNZILLA" | "GUNZILLA_TESTNET" | "SEI" | "SEI_TESTNET" | "B3_SEPOLIA" | "B3" |  "APE_CHAIN" | "APE_CURTIS" | "SONEIUM_MINATO" | "SONEIUM" | "RONIN" | "BERA_CHAIN" | "SHAPE" | "UNICHAIN" | "MONAD_TESTNET" | "SAIGON_TESTNET" | "ABSTRACT_TESTNET" | "%future added value" | null | undefined;
};
export type useFetchAllWalletBalancesQuery$data = {
  readonly wallet: {
    readonly funds: ReadonlyArray<{
      readonly chain: ChainIdentifier;
      readonly image: string | null | undefined;
      readonly name: string | null | undefined;
      readonly quantity: string;
      readonly symbol: string;
      readonly usdPrice: string | null | undefined;
    }>;
  };
};
export type useFetchAllWalletBalancesQuery = {
  response: useFetchAllWalletBalancesQuery$data;
  variables: useFetchAllWalletBalancesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "address"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "chain"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "address",
    "variableName": "address"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "chain",
    "variableName": "chain"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chain",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usdPrice",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFetchAllWalletBalancesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletType",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WalletFundsType",
            "kind": "LinkedField",
            "name": "funds",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchAllWalletBalancesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletType",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "WalletFundsType",
            "kind": "LinkedField",
            "name": "funds",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c06c18579442550c69136653b8516dcc",
    "id": null,
    "metadata": {},
    "name": "useFetchAllWalletBalancesQuery",
    "operationKind": "query",
    "text": "query useFetchAllWalletBalancesQuery(\n  $address: AddressScalar!\n  $chain: ChainScalar\n) {\n  wallet(address: $address) {\n    funds(chain: $chain) {\n      symbol\n      chain\n      quantity\n      usdPrice\n      image\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99afc3381aad0a47d2622af60735ff61";

export default node;
